<template>
  <b-row class="justify-content-md-center">
    <b-col md="6">
      <text-terms-and-condition @redirect="redirect" class="d-none"/>

      <b-modal
        v-model="modal_check_email"
        size="lg"
        centered
        hide-footer
        title="Activa tu cuenta"
        @hidden="modalClosed"
      >
        <div class="demo-inline-spacing pb-2">
          <feather-icon icon="MailIcon" size="32" />
          <feather-icon icon="ArrowRightIcon" size="32" />
          <feather-icon icon="CheckCircleIcon" size="32" />
        </div>
        <b-card-text class="text-dark">
         {{ $t('campaigns.stepGo') }}
          <strong>{{ email }}</strong> {{ $t('campaigns.clicActive') }}
        </b-card-text>
        <b-card-text
          class="text-dark"
        >
        {{ $t('campaigns.checkTray') }}
        </b-card-text>
        <div class="block">
          <b-button
            @click="resend()"
            variant="no-outline"
            size="lg"
            class="mt-1 no-outline"
            >{{ $t('campaigns.forwardEmail') }}</b-button
          >
          <b-button @click="`${is_realty ? nextRealty() : next()}`" variant="primary" size="lg" class="mt-1"
            >{{ $t('campaigns.perfect') }}</b-button
          >
        </div>
      </b-modal>
      <modal-redirect :show_modal="show_modal" :key="change_modal" @close="showConfetti">
        <template #body>
          <div v-if="getUserData().main_group.name !== 'creator'">
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'home_search'}); showConfetti()">{{ $t('goProposal') }}</b-button>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'my_work_brands', params: {section: 'campaigns'}}); showConfetti()">{{ $t('goCreateCampaign') }}</b-button>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'analyzer'}); showConfetti()">{{ $t('goSearch') }}</b-button>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'campaigns'}); showConfetti()">{{ $t('goCampaign') }}</b-button>
          </div>
          <div v-else>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'marcas'}); showConfetti()">{{ $t('pitch_brands_go_modal') }}</b-button>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'view_proposals_edit'}); showConfetti()">{{ $t('create_proposal_go_modal') }}</b-button>
            <b-button class="col-12 btn-redirect" variant="btn-redirect" @click="$router.push({name: 'dashboard-analytics'}); showConfetti()">{{ $t('go_to_home') }}</b-button>
          </div>
        </template>
      </modal-redirect>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCardText,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import service from "@/services/others";
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import config from "@/services/config";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import TextTermsAndCondition from "./TextTermsAndCondition.vue";
import modalRedirect from "@/views/components/modal/modalRedirect.vue";
import { getUserData } from '@/libs/utils/user';
import { showConfetti } from '@/libs/utils/others'

export default {
  components: {
    modalRedirect,
    BCardText,
    BRow,
    BCol,
    BButton,
    TextTermsAndCondition
  },
  data() {
    return {
      showConfetti,
      getUserData,
      clicked: false,
      email: "",
      show_modal: false,
      change_modal: false,
      modal_check_email: false,
      is_realty: getUserData() && getUserData().main_group && getUserData().main_group.name === 'realty' ? 'realty' : '',
    };
  },
  created() {
    this.email = this.getEmail();
    if (getUserData().main_group.name !== 'creator') this.next();
    else this.showModal();
  },
  mounted() {

  },
  destroyed() {
    const principal_nav = document.querySelector('ul.nav.navbar-nav.d-xl-none');
    if (principal_nav) principal_nav.style.setProperty('display', 'block', 'important')
    const second_nav = document.getElementsByClassName('width-new')[0];
    if (second_nav) second_nav.style.setProperty('display', 'block', 'important');

    const body = document.querySelector('div.app-content.content');
    body.removeAttribute('style');
  },
  methods: {
    modalClosed() {
      this.is_realty ? this.nextRealty() : this.next()
    },
    getEmail() {
      const user = JSON.parse(localStorage.userData);
      return user.email;
    },
    getAcceptTC() {
      return localStorage.accept_tyc !== 'false';
    },
    resend() {
      service
        .sendEmailPass({ email: this.email }, true)
        .then(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.sendEmail'),
                icon: "EditIcon",
                variant: "success",
              }
            })
          })
        })
        .catch(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.errorSendEmail'),
                icon: "EditIcon",
                variant: "success",
              }
            })
          })
        });
    },
    nextRealty() {
      this.$router.push({name: 'campaigns'})
    },
    next() {

      // if (utils.getUserData().main_group.name === 'creator') {
      //   const user = JSON.parse(localStorage.userData);
      //   const route = getHomeRouteForLoggedInUser(user)
      //   this.$router.push(route);
      // } else {
      //   this.modal_check_email = false;
      // }
      if (this.is_realty) {
        this.show_modal = false
        this.modal_check_email = true;
        this.change_modal = true
      } else {
        this.show_modal = true
        this.change_modal = true
      }
    },
    showModal() {
      this.modal_check_email = true;
    },
    redirect() {
      const user = JSON.parse(localStorage.userData);
 
      this.clicked = true;
      const auth = {
        Authorization: `Bearer ${localStorage.token}`,
      };

      this.$http
        .post(`${config.urlCore}/api/v1/accounts/accept-tyc/`, {
          headers: auth,
        })
        .then((response) => {
          if (response.status !== 200) this.clicked = false;

          localStorage.setItem("accept_tyc", true);

          if (!user.is_verified) {
            this.showModal();
          } else {
            if (user.roll === null) {
              this.$router.push("/roll");
            }
            this.next();
          }
        })
        .catch(() => {
          this.clicked = false;
        });
    },
    deleteAccount() {
      const auth = {
        Authorization: `Bearer ${localStorage.token}`,
      };
      this.$http
        .post(`${config.urlCore}/api/v1/accounts/delete-account/`, {
          headers: auth,
        })
        .then(() => {
          localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
          localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

          localStorage.removeItem("userData");
          localStorage.removeItem("accept_tyc");

          this.$ability.update(initialAbility);

          this.$router.push("/adios");
        })
        .catch(() => {
          this.clicked = false;
        });
    },
  },
};
</script>

<style>
.no-outline {
  color: rgb(164, 164, 164);
}
</style>
